import { i18n } from '@lingui/core'

export const locales = { en: 'English', fr: 'Français', de: 'Deutsch' } as const
export type Locale = keyof typeof locales

export const defaultLocale: Locale = 'en'

export async function activateLocale(locale: Locale) {
  const { messages } = await import(`./locales/${locale}.po`)
  i18n.load(locale, messages)
  i18n.activate(locale)
  // Guard against post-teardown / non-DOM environments. The dynamic import
  // above can resolve after vitest tears down jsdom, which makes `document`
  // undefined and surfaces as an unhandled rejection that fails CI.
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale
  }
}

export { i18n }
